import { render, staticRenderFns } from "./DimmingDialog.vue?vue&type=template&id=4cf8352a&"
import script from "./DimmingDialog.vue?vue&type=script&lang=js&"
export * from "./DimmingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports